<template>
  <div class="new-contract-manage-container">
    <!-- 查询条件 -->
    <el-card class="search-card">
      <div slot="header" class="flex justify-between">
        <span>查询条件</span>
      </div>
      <el-row :gutter="20">
        <el-col :span="6">
          <el-input v-model.trim="searchForm.contractNameLike"
            placeholder="请输入合同名称" clearable />
        </el-col>
        <el-col :span="6">
          <el-input v-model.trim="searchForm.contractCode"
            placeholder="请输入合同编号" clearable />
        </el-col>
        <el-col :span="6">
          <el-select v-model="searchForm.contractType"
            placeholder="请选择合同类型" style="width:100%">
            <el-option v-for="item in contractTypes" :key="item.contractTypeId" :label="item.typeName"
              :value="item.contractTypeId" />
          </el-select>
        </el-col>
        <el-col :span="6">
          <el-button type="primary" @click="handleSearch">
            <i class="el-icon-search"></i>
            查询
          </el-button>
          <el-button @click="handleReset">
            <i class="el-icon-refresh"></i>
            重置
          </el-button>
        </el-col>
      </el-row>
    </el-card>

    <!-- 合同列表 -->
    <el-card class="table-card">
      <div slot="header" class="flex justify-between">
        <span>起草合同信息</span>
        <el-button type="primary" size="small" @click="handleAdd">
          <i class="el-icon-plus"></i>
          起草
        </el-button>
      </div>

      <el-table v-loading="loading" :data="tableData" border style="width:100%">
        <el-table-column prop="contractName" label="合同名称" align="center" />
        <el-table-column prop="contractCode" label="合同编号" align="center" />
        <el-table-column prop="parentContractCode" label="父合同编号"
          align="center">
          <template slot-scope="scope">
            {{ scope.row.parentContractCode || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="contractTypeName" label="合同类型" align="center" />
        <el-table-column prop="operator" label="经办人" align="center" />
        <el-table-column prop="amount" label="合同金额" align="center" />
        <el-table-column prop="startTime" label="开始时间" align="center" />
        <el-table-column prop="endTime" label="结束时间" align="center" />
        <el-table-column prop="stateName" label="状态" align="center" />
        <el-table-column label="操作" align="center" width="220">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="handleEdit(scope.row)">
              编辑
            </el-button>
            <el-button size="mini" type="danger" @click="handleDelete(scope.row)">
              删除
            </el-button>
            <el-button size="mini" @click="handlePrint(scope.row)">
              打印
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="note-text">
        注意：此功能使用前请先到系统管理>流程管理中设置合同申请续签
      </div>

      <el-pagination :current-page="pagination.current" :page-sizes="[10, 20, 30, 50]" :page-size="pagination.size"
        :total="pagination.total" layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange"
        @current-change="handleCurrentChange" />
    </el-card>

    <!-- 编辑合同组件 -->
    <edit-contract ref="editContract" @success="fetchData" />

    <!-- 删除合同组件 -->
    <delete-contract ref="deleteContract" @success="fetchData" />
  </div>
</template>

<script>
import { getContractList, getContractTypeList } from '@/api/contract/newContractManageApi'
import EditContract from '@/components/contract/editContract'
import DeleteContract from '@/components/contract/deleteContract'
import { getCommunityId } from '@/api/community/communityApi'

export default {
  name: 'NewContractManageList',
  components: {
    EditContract,
    DeleteContract
  },
  data() {
    return {
      loading: false,
      searchForm: {
        contractNameLike: '',
        contractCode: '',
        contractType: '',
        state: ''
      },
      tableData: [],
      contractTypes: [],
      pagination: {
        current: 1,
        size: 10,
        total: 0
      },
      communityId: ''
    }
  },
  created() {
    this.communityId = getCommunityId()
    this.fetchData()
    this.fetchContractTypes()
  },
  methods: {
    async fetchData() {
      try {
        this.loading = true
        const params = {
          page: this.pagination.current,
          row: this.pagination.size,
          ...this.searchForm,
          communityId: this.communityId
        }
        const { data, total } = await getContractList(params)
        this.tableData = data
        this.pagination.total = total
      } catch (error) {
        this.$message.error('获取合同数据失败')
      } finally {
        this.loading = false
      }
    },
    async fetchContractTypes() {
      try {
        const params = {
          page: 1,
          row: 100
        }
        const { data } = await getContractTypeList(params)
        this.contractTypes = data
      } catch (error) {
        console.error('获取合同类型失败:', error)
      }
    },
    handleSearch() {
      this.pagination.current = 1
      this.fetchData()
    },
    handleReset() {
      this.searchForm = {
        contractNameLike: '',
        contractCode: '',
        contractType: '',
        state: ''
      }
      this.handleSearch()
    },
    handleAdd() {
      this.$router.push('/views/contract/addContract')
    },
    handleEdit(row) {
      this.$refs.editContract.open(row)
    },
    handleDelete(row) {
      this.$refs.deleteContract.open(row)
    },
    handlePrint(row) {
      window.open(`/#/views/contract/printContract?contractTypeId=${row.contractType}&contractId=${row.contractId}`)
    },
    handleSizeChange(val) {
      this.pagination.size = val
      this.pagination.current = 1
      this.fetchData()
    },
    handleCurrentChange(val) {
      this.pagination.current = val
      this.fetchData()
    }
  }
}
</script>

<style lang="scss" scoped>
.new-contract-manage-container {
  padding: 20px;

  .search-card {
    margin-bottom: 20px;
  }

  .table-card {
    margin-bottom: 20px;
  }

  .note-text {
    margin: 15px 0;
    color: #999;
    font-size: 14px;
  }

  .el-pagination {
    margin-top: 20px;
    text-align: right;
  }
}
</style>